<template>
  <div>
    <PChart
        type="line"
        title="Analytics"
        height="250"
        :series="series"
        :x-axis="xAxis"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  props: {
      chartData: {
          type: Number
      }
  },
  computed:{
    xAxis(){
      return this.chartData.labels
    },
    series(){
      return [
        {
          name: 'Clicks',
          data: this.chartData.datasets[0].data
        },
        {
          name: 'Sessions',
          data: this.chartData.datasets[1].data
        }
      ]
    }
  }
}
</script>